import { RefObject } from "react";
import { react } from "uikit";

import { PaymentProvider } from "../../../../../../../../../services/PaymentSystem";
import Name from "../../../../../components/Name";
import RefundPolicy from "../../../../../components/RefundPolicy";
import CompaniesAndTaxiServices from "../../../../../components/CompaniesAndTaxiServices";
import AssetPayment from "../../../../../components/AssetPayment";
import DinarPayment from "../../../../../components/DinarPayment";
import BogPayment from "../../../../../components/BogPayment";
import CybersourcePayment from "../../../../../components/CybersourcePayment";
import PlatonPayment from "../../../../../components/PlatonPayment";
import MonobankPayment from "../../../../../components/MonobankPayment";
import SystemFee from "../../../../../components/SystemFee";
import SelectPaymentSystems from "../../../../../components/SelectPaymentSystems";

interface Context {
	refundPolicyRef: RefObject<RefundPolicy.Ref | null>;
	nameRef: RefObject<Name.Ref | null>;
	companyBranchRef: RefObject<CompaniesAndTaxiServices.Ref | null>;
	assetPaymentRef: RefObject<AssetPayment.Ref | null>;
	dinarPaymentRef: RefObject<DinarPayment.Ref | null>;
	bogPaymentRef: RefObject<BogPayment.Ref | null>;
	cybersourcePaymentRef: RefObject<CybersourcePayment.Ref | null>;
	platonPaymentRef: RefObject<PlatonPayment.Ref | null>;
	monobankPaymentRef: RefObject<MonobankPayment.Ref | null>;
	systemFeeRef: RefObject<SystemFee.Ref | null>;
	paymentSystemRef: RefObject<SelectPaymentSystems.Ref | null>;
	paymentProviderValue: PaymentProvider;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isRefundPolicyValid =
			this.context?.refundPolicyRef.current?.validate() ?? true;
		const isBaseValid = this.validateBase();

		return isRefundPolicyValid && isBaseValid;
	}

	private validateBase() {
		const isNameValid = !!this.context?.nameRef.current?.validate();
		const isBranchesValid =
			!!this.context?.companyBranchRef.current?.validate();

		const assetPayment = this.context?.assetPaymentRef.current?.validate();

		const dinarPayment = this.context?.dinarPaymentRef.current?.validate();

		const bogPayment = this.context?.bogPaymentRef.current?.validate();

		const cybersourcePayment =
			this.context?.cybersourcePaymentRef.current?.validate();

		const platonPayment =
			this.context?.platonPaymentRef.current?.validate();

		const monobankPayment =
			this.context?.monobankPaymentRef.current?.validate();

		const systemFee = this.context?.systemFeeRef.current?.validate();

		const paymentSystem =
			this.context?.paymentSystemRef.current?.validate();

		const paymentProviderValue = this.context?.paymentProviderValue;

		const isValid = [
			isNameValid,
			isBranchesValid,
			paymentSystem,
			!!paymentProviderValue,
		];

		if (paymentProviderValue === PaymentProvider.ASSETPAYMENT) {
			isValid.push(assetPayment);
			return isValid.every((isValid) => isValid);
		}

		if (paymentProviderValue === PaymentProvider.DINARPAY) {
			isValid.push(dinarPayment);
			return isValid.every((isValid) => isValid);
		}

		if (paymentProviderValue === PaymentProvider.BOG) {
			isValid.push(bogPayment);
			return isValid.every((isValid) => isValid);
		}

		if (paymentProviderValue === PaymentProvider.CYBERSOURCE) {
			isValid.push(cybersourcePayment);
			return isValid.every((isValid) => isValid);
		}

		if (paymentProviderValue === PaymentProvider.PLATON) {
			isValid.push(platonPayment);
			return isValid.every((isValid) => isValid);
		}

		if (paymentProviderValue === PaymentProvider.MONOBANK) {
			isValid.push(monobankPayment);
			return isValid.every((isValid) => isValid);
		}

		return false;
	}
}
